export default {
  QUERY_BANNER_OVERVIEW: {
    url: '/api/v1/admin/banners/overview',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  QUERY_BANNER: {
    url: '/api/v1/banners',
    method: 'get',
    disableSuccessMsg: false,
    disableErrorMsg: false
  },
  SAVE_BANNER: {
    url: '/api/v1/admin/banners',
    method: 'post',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  PUT_BANNER: {
    url: '/api/v1/admin/banners',
    method: 'put',
    disableSuccessMsg: true,
    disableErrorMsg: false
  },
  DELETE_BANNER: {
    url: '/api/v1/admin/banners',
    method: 'delete',
    disableSuccessMsg: false,
    disableErrorMsg: false
  }
}
